import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../store'

export const layoutSelector = (state: RootState) => state.layout

export const isRTLSelector = createSelector(layoutSelector, selected => selected.isRTL)
export const skinSelector = createSelector(layoutSelector, selected => selected.skin)
export const menuCollapsedSelector = createSelector(layoutSelector, selected => selected.menuCollapsed)
export const menuHiddenSelector = createSelector(layoutSelector, selected => selected.menuHidden)
export const contentWidthSelector = createSelector(layoutSelector, selected => selected.contentWidth)
